import React, { useState, useEffect, useCallback } from 'react';
import {
    Box, Grid, Checkbox, FormControlLabel, Button, Typography, Paper, TextField
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import axios from 'axios';
import { apiATC, localization } from '../../config';
import FilterInput from '../../components/filterInput';
import FilterSelect from '../../components/filterSelect';
import { useSelector, useDispatch } from 'react-redux';
import { getTypeTarif } from '../../actions';

const useStyles = makeStyles((theme) => ({
    pageContainer: {
        padding: theme.spacing(3),
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.palette.background.default,
    },
    controlsContainer: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
        boxShadow: theme.shadows[2],
        flexShrink: 0,
        maxHeight: '200px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: theme.palette.grey[100],
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.grey[600],
            borderRadius: '4px',
        },
    },
    sectionTitle: {
        marginBottom: theme.spacing(1.5),
        fontWeight: 'bold',
        color: theme.palette.text.primary,
        fontSize: '1.1rem',
    },
    filterGroup: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2),
        alignItems: 'flex-start',
        width: '100%',
        paddingTop: theme.spacing(0),
    },
    filterItemWrapper: {
        flex: '1 1 200px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minWidth: '150px',
    },
    priceFilterItemWrapper: {
        flex: '1 1 120px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        minWidth: '80px',
    },
    priceTextField: {
        // ... (vos styles existants pour priceTextField)
    },
    topControlsRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        gap: theme.spacing(3),
        alignItems: 'flex-start',
        width: '100%',
        justifyContent: 'space-between',
        overflowX: 'auto',
        paddingBottom: theme.spacing(1),
        '&::-webkit-scrollbar': {
            height: '8px',
        },
        '&::-webkit-scrollbar-track': {
            background: theme.palette.grey[100],
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: theme.palette.grey[400],
            borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: theme.palette.grey[600],
            borderRadius: '4px',
        },
    },
    filterGroupWrapper: {
        flex: '2 1 60%',
        minWidth: '350px',
        paddingTop: 0,
    },
    groupByWrapper: {
        flex: '1 1 30%',
        minWidth: '220px',
        paddingLeft: theme.spacing(3),
        borderLeft: `1px solid ${theme.palette.divider}`,
        paddingTop: 0,
        borderTop: 'none',
    },
    buttonWrapper: {
        flex: '0 0 auto',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        minWidth: '150px',
        marginTop: theme.spacing(2),
    },
    groupByCheckboxes: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    checkboxLabel: {
        margin: 0,
        '& .MuiCheckbox-root': {
            padding: theme.spacing(0.5),
        },
        '& .MuiFormControlLabel-label': {
            fontSize: '0.85rem',
            color: theme.palette.text.secondary,
            whiteSpace: 'nowrap',
        },
    },
    tableGridItem: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    materialTableOverrides: {
        '&.MuiPaper-root': {
            boxShadow: theme.shadows[1],
            borderRadius: theme.shape.borderRadius,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            overflow: 'hidden',
        },
        '& .MuiTableContainer-root': {
            flexGrow: 1,
            overflowY: 'auto',
            '&::-webkit-scrollbar': { width: '8px' },
            '&::-webkit-scrollbar-track': { background: theme.palette.grey[100] },
            '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.grey[400], borderRadius: '4px' },
            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.grey[600], borderRadius: '4px' },
        },
        '& .MuiToolbar-root': {
            minHeight: '48px',
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            borderTopLeftRadius: theme.shape.borderRadius,
            borderTopRightRadius: theme.shape.borderRadius,
        },
        '& .MuiTableBody-root .MuiTableCell-root': {
            padding: '12px 16px',
            fontSize: '0.875rem',
            color: theme.palette.text.primary,
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiTableHead-root .MuiTableCell-head': {
            padding: '12px 16px',
            fontSize: '0.9rem',
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.grey[50],
            color: theme.palette.text.secondary,
            borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiTablePagination-root': {
            flexShrink: 0,
            padding: theme.spacing(1, 2),
            borderTop: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiTableSortLabel-icon': {
            color: `${theme.palette.text.secondary} !important`,
        },
        '& .MuiTableRow-root:hover': {
            backgroundColor: `${theme.palette.action.hover} !important`,
        },
        '& .MuiTypography-h6': {
            fontSize: '1.1rem',
            fontWeight: theme.typography.fontWeightMedium,
            color: 'inherit',
        },
        '& .MuiTableCell-body:has([role="gridcell"][colspan])': {
            textAlign: 'center',
            fontStyle: 'italic',
            color: theme.palette.text.secondary,
            padding: theme.spacing(4),
        }
    },
}));

export default function AnalysePrix() {
    const classes = useStyles();

    const [groupBy, setGroupBy] = useState({
        type_produit: true,
        tarif_produit: true,
        tranche_prix_r: true
    });
    const [rawData, setRawData] = useState([]);
    const [data, setData] = useState([]);
    const [rawDetailData, setRawDetailData] = useState([]);
    const [detailData, setDetailData] = useState([]);
    const [rawInconsistencyData, setRawInconsistencyData] = useState([]);
    const [inconsistencyData, setInconsistencyData] = useState([]);


    const [filterValues, setFilterValues] = useState({
        ref: '',
        idTarifProd: '',
        prixMin: '',
        prixMax: '',
    });

    const [sortOrderSynthesis, setSortOrderSynthesis] = useState({ orderBy: null, orderDirection: 'asc' });
    const [sortOrderDetail, setSortOrderDetail] = useState({ orderBy: null, orderDirection: 'asc' });
    const [sortOrderInconsistency, setSortOrderInconsistency] = useState({ orderBy: 'date_fact', orderDirection: 'desc' });


    const dispatch = useDispatch();
    const listeTarifProduit = useSelector(state => state.generalData.listeTypeTarif || []);

    useEffect(() => {
        dispatch(getTypeTarif());
    }, [dispatch]);

    const sortData = useCallback((dataToSort, orderByField, orderDirection) => {
        if (!orderByField || !dataToSort) return dataToSort;

        const sorted = [...dataToSort].sort((a, b) => {
            const aValue = a[orderByField];
            const bValue = b[orderByField];

            if (aValue === null || aValue === undefined) return orderDirection === 'asc' ? 1 : -1;
            if (bValue === null || bValue === undefined) return orderDirection === 'asc' ? -1 : 1;

            if (typeof aValue === 'number' && typeof bValue === 'number') {
                return orderDirection === 'asc' ? aValue - bValue : bValue - aValue;
            } else {
                const comparison = String(aValue).localeCompare(String(bValue), undefined, { numeric: true, sensitivity: 'base' });
                return orderDirection === 'asc' ? comparison : -comparison;
            }
        });
        return sorted;
    }, []);

    useEffect(() => {
        if (rawData.length > 0 && sortOrderSynthesis.orderBy) {
            setData(sortData(rawData, sortOrderSynthesis.orderBy, sortOrderSynthesis.orderDirection));
        } else {
            setData(rawData);
        }
    }, [rawData, sortOrderSynthesis, sortData]);

    useEffect(() => {
        if (rawDetailData.length > 0 && sortOrderDetail.orderBy) {
            setDetailData(sortData(rawDetailData, sortOrderDetail.orderBy, sortOrderDetail.orderDirection));
        } else {
            setDetailData(rawDetailData);
        }
    }, [rawDetailData, sortOrderDetail, sortData]);

    useEffect(() => {
        if (rawInconsistencyData.length > 0 && sortOrderInconsistency.orderBy) {
            setInconsistencyData(sortData(rawInconsistencyData, sortOrderInconsistency.orderBy, sortOrderInconsistency.orderDirection));
        } else {
            setInconsistencyData(rawInconsistencyData);
        }
    }, [rawInconsistencyData, sortOrderInconsistency, sortData]);


    const buildColumns = (currentGroupBy) => {
        const base = {
            type_produit: { title: 'Type Produit', field: 'type_produit_label' },
            tarif_produit: { title: 'Tarif Produit', field: 'tarif_produit_label' },
            tranche_prix_r: { title: 'Tranche Prix R', field: 'tranche_prix_r' }
        };

        const dynamicCols = Object.entries(currentGroupBy)
            .filter(([key, checked]) => checked && base[key])
            .map(([key]) => ({
                ...base[key],
                sorting: true,
                cellStyle: { whiteSpace: 'nowrap', maxWidth: 180 },
                headerStyle: { maxWidth: 180, fontWeight: 'bold' }
            }));

        return [
            ...dynamicCols,
            // {
            //     title: 'Coef. Min',
            //     field: 'min_coeff',
            //     type: 'numeric',
            //     sorting: true,
            //     render: rowData => Number(rowData.min_coeff).toFixed(2),
            //     cellStyle: { textAlign: 'right', maxWidth: 100 },
            //     headerStyle: { maxWidth: 100, textAlign: 'right', fontWeight: 'bold' }
            // },
            // {
            //     title: 'Coef. Max',
            //     field: 'max_coeff',
            //     type: 'numeric',
            //     sorting: true,
            //     render: rowData => Number(rowData.max_coeff).toFixed(2),
            //     cellStyle: { textAlign: 'right', maxWidth: 100 },
            //     headerStyle: { maxWidth: 100, textAlign: 'right', fontWeight: 'bold' }
            // },
            {
                title: 'Écart Type Coef.',
                field: 'ecart_type_coeff',
                type: 'numeric',
                sorting: true,
                render: rowData => Number(rowData.ecart_type_coeff).toFixed(2),
                cellStyle: { textAlign: 'right', maxWidth: 120 },
                headerStyle: { maxWidth: 120, textAlign: 'right', fontWeight: 'bold' }
            },
            {
                title: 'Coef. Moyen',
                field: 'moyenne_rapport',
                type: 'numeric',
                sorting: true,
                render: rowData => Number(rowData.moyenne_rapport).toFixed(2),
                cellStyle: { textAlign: 'right', maxWidth: 100 },
                headerStyle: { maxWidth: 100, textAlign: 'right', fontWeight: 'bold' }
            },
            {
                title: 'Nombre',
                field: 'nombre',
                type: 'numeric',
                sorting: true,
                cellStyle: { textAlign: 'right', maxWidth: 120 },
                headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 120 }
            }
        ];
    };

    const detailColumns = [
        { title: 'Date Facture', field: 'date_fact', type: 'date', headerStyle: { fontWeight: 'bold', maxWidth: 150 } },
        { title: 'Référence', field: 'ref_centre_vide', headerStyle: { fontWeight: 'bold', maxWidth: 150 } },
        {
            title: 'Désignation',
            field: 'designation',
            cellStyle: { minWidth: 280, whiteSpace: 'normal', wordWrap: 'break-word' },
            headerStyle: { minWidth: 280, fontWeight: 'bold' }
        },
        {
            title: 'TotHT',
            field: 'totht',
            type: 'numeric',
            render: rowData => `${Number(rowData.totht).toFixed(0)} €`,
            cellStyle: { textAlign: 'right', maxWidth: 100 },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        {
            title: 'Prix R',
            field: 'prix_r',
            type: 'numeric',
            render: rowData => `${Number(rowData.prix_r).toFixed(0)} €`,
            cellStyle: { textAlign: 'right', maxWidth: 100 },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        {
            title: 'Coef.',
            field: 'rapport',
            type: 'numeric',
            render: rowData => Number(rowData.rapport).toFixed(2),
            cellStyle: { textAlign: 'right', maxWidth: 100 },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        { title: 'Sachet', field: 'num_sachet', type: 'numeric', headerStyle: { fontWeight: 'bold', maxWidth: 100 } }
    ];

    const inconsistencyColumns = [
        { title: 'Date Facture', field: 'date_fact', type: 'date', headerStyle: { fontWeight: 'bold', maxWidth: 150 } },
        { title: 'Référence', field: 'ref_centre_vide', headerStyle: { fontWeight: 'bold', maxWidth: 150 } },
        {
            title: 'Désignation',
            field: 'designation',
            cellStyle: { minWidth: 280, whiteSpace: 'normal', wordWrap: 'break-word' },
            headerStyle: { minWidth: 280, fontWeight: 'bold' }
        },
        {
            title: 'TotHT',
            field: 'totht',
            type: 'numeric',
            render: rowData => `${Number(rowData.totht).toFixed(0)} €`,
            cellStyle: { textAlign: 'right', maxWidth: 100 },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        {
            title: 'Prix R',
            field: 'prix_r',
            type: 'numeric',
            render: rowData => `${Number(rowData.prix_r).toFixed(0)} €`,
            cellStyle: { textAlign: 'right', maxWidth: 100 },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        {
            title: 'Coef.',
            field: 'rapport',
            type: 'numeric',
            render: rowData => Number(rowData.rapport).toFixed(2),
            cellStyle: { textAlign: 'right', maxWidth: 100, fontWeight: 'bold', color: 'red' },
            headerStyle: { textAlign: 'right', fontWeight: 'bold', maxWidth: 100 }
        },
        { title: 'Sachet', field: 'num_sachet', type: 'numeric', headerStyle: { fontWeight: 'bold', maxWidth: 100 } }
    ];


    const fetchData = async (currentGroupBy) => {
        const active = Object.entries(currentGroupBy)
            .filter(([_, v]) => v)
            .map(([k]) => k);

        if (active.length === 0) {
            alert('Veuillez sélectionner au moins un critère de regroupement pour afficher les données.');
            return;
        }
        try {
            const res = await axios.post(`${apiATC}/produit/produit.php?action=analyse_tarif`, {
                group_by: active,
                ref: filterValues.ref,
                idTarifProd: filterValues.idTarifProd,
                prixMin: filterValues.prixMin === '' ? null : parseFloat(filterValues.prixMin),
                prixMax: filterValues.prixMax === '' ? null : parseFloat(filterValues.prixMax),
            });
            setRawData(res.data);
            setData(sortData(res.data, sortOrderSynthesis.orderBy, sortOrderSynthesis.orderDirection));

            setRawDetailData([]);
            setDetailData([]);
        } catch (e) {
            console.error("Error fetching analysis data:", e);
            alert("Une erreur est survenue lors de la récupération des données d'analyse. Veuillez réessayer.");
        }
    };

    const fetchDetail = async (row) => {
        try {
            const payload = {
                type_produit_id: row.type_produit_id || null,
                tarif_produit_id: row.tarif_produit_id || null,
                tranche_prix_r: row.tranche_prix_r || null,
                ref: filterValues.ref,
                global_idTarifProd: filterValues.idTarifProd,
                prixMin: filterValues.prixMin === '' ? null : parseFloat(filterValues.prixMin),
                prixMax: filterValues.prixMax === '' ? null : parseFloat(filterValues.prixMax),
            };
            const res = await axios.post(`${apiATC}/produit/produit.php?action=detail_tarif`, payload);
            setRawDetailData(res.data);
            setDetailData(sortData(res.data, sortOrderDetail.orderBy, sortOrderDetail.orderDirection));
        } catch (e) {
            console.error("Error fetching detail data:", e);
            alert("Une erreur est survenue lors de la récupération des données détaillées. Veuillez réessayer.");
        }
    };

    const fetchInconsistencies = async () => {
        try {
            const res = await axios.post(`${apiATC}/produit/produit.php?action=analyse_tarif_incoherence`, {
                ref: filterValues.ref,
                global_idTarifProd: filterValues.idTarifProd,
                prixMin: filterValues.prixMin === '' ? null : parseFloat(filterValues.prixMin),
                prixMax: filterValues.prixMax === '' ? null : parseFloat(filterValues.prixMax),
                // individual_min_rapport_threshold and individual_max_rapport_threshold are now fixed in PHP
            });
            setRawInconsistencyData(res.data);
            setInconsistencyData(sortData(res.data, sortOrderInconsistency.orderBy, sortOrderInconsistency.orderDirection));
        } catch (e) {
            console.error("Error fetching inconsistency data:", e);
            alert("Une erreur est survenue lors de la récupération des données d'incohérence. Veuillez réessayer.");
        }
    };


    const handleFilterValueChange = (value, filterName) => {
        setFilterValues(prev => ({ ...prev, [filterName]: value }));
    };

    const handleSynthesisOrderChange = useCallback((newOrderByIndex, _ignoredOrderDirection) => {
        const columns = buildColumns(groupBy);
        const newOrderByField = (newOrderByIndex >= 0 && newOrderByIndex < columns.length)
            ? columns[newOrderByIndex].field
            : null;

        setSortOrderSynthesis(prevSortOrder => {
            let nextOrderDirection = 'asc';
            if (prevSortOrder.orderBy === newOrderByField) {
                if (prevSortOrder.orderDirection === 'asc') {
                    nextOrderDirection = 'desc';
                } else if (prevSortOrder.orderDirection === 'desc') {
                    nextOrderDirection = 'asc';
                }
            }
            return { orderBy: newOrderByField, orderDirection: nextOrderDirection };
        });
    }, [groupBy]);

    const handleDetailOrderChange = useCallback((newOrderByIndex, _ignoredOrderDirection) => {
        const columns = detailColumns;
        const newOrderByField = (newOrderByIndex >= 0 && newOrderByIndex < columns.length)
            ? columns[newOrderByIndex].field
            : null;

        setSortOrderDetail(prevSortOrder => {
            let nextOrderDirection = 'asc';
            if (prevSortOrder.orderBy === newOrderByField) {
                if (prevSortOrder.orderDirection === 'asc') {
                    nextOrderDirection = 'desc';
                } else if (prevSortOrder.orderDirection === 'desc') {
                    nextOrderDirection = 'asc';
                }
            }
            return { orderBy: newOrderByField, orderDirection: nextOrderDirection };
        });
    }, [detailColumns]);

    const handleInconsistencyOrderChange = useCallback((newOrderByIndex, _ignoredOrderDirection) => {
        const columns = inconsistencyColumns;
        const newOrderByField = (newOrderByIndex >= 0 && newOrderByIndex < columns.length)
            ? columns[newOrderByIndex].field
            : null;

        setSortOrderInconsistency(prevSortOrder => {
            let nextOrderDirection = 'asc';
            if (prevSortOrder.orderBy === newOrderByField) {
                if (prevSortOrder.orderDirection === 'asc') {
                    nextOrderDirection = 'desc';
                } else if (prevSortOrder.orderDirection === 'desc') {
                    nextOrderDirection = 'asc';
                }
            }
            return { orderBy: newOrderByField, orderDirection: nextOrderDirection };
        });
    }, [inconsistencyColumns]);


    return (
        <Box className={classes.pageContainer}>
            <Paper elevation={2} className={classes.controlsContainer}>
                <Box className={classes.topControlsRow}>
                    {/* Filter Section */}
                    <Box className={classes.filterGroupWrapper}>
                        <Box className={classes.filterGroup}>
                            <div className={classes.filterItemWrapper}>
                                <FilterInput
                                    label='Référence'
                                    type='text'
                                    onChange={(value) => handleFilterValueChange(value, 'ref')}
                                    value={filterValues.ref}
                                    variant="outlined"
                                    margin="dense"
                                />
                            </div>

                            <div className={classes.filterItemWrapper}>
                                <FilterSelect
                                    label='Tarif Produit'
                                    labelId='id'
                                    onChange={(value) => handleFilterValueChange(value, 'idTarifProd')}
                                    options={listeTarifProduit}
                                    value={filterValues.idTarifProd}
                                    labelDescription="description"
                                    variant="outlined"
                                    margin="dense"
                                />
                            </div>

                            <div className={classes.priceFilterItemWrapper}>
                                <TextField
                                    label="Prix Min (€)"
                                    type="number"
                                    variant="outlined"
                                    margin="dense"
                                    value={filterValues.prixMin}
                                    onChange={(e) => handleFilterValueChange(e.target.value, 'prixMin')}
                                    InputLabelProps={{ shrink: true }}
                                    className={classes.priceTextField}
                                    fullWidth
                                />
                            </div>

                            <div className={classes.priceFilterItemWrapper}>
                                <TextField
                                    label="Prix Max (€)"
                                    type="number"
                                    variant="outlined"
                                    margin="dense"
                                    value={filterValues.prixMax}
                                    onChange={(e) => handleFilterValueChange(e.target.value, 'prixMax')}
                                    InputLabelProps={{ shrink: true }}
                                    className={classes.priceTextField}
                                    fullWidth
                                />
                            </div>
                        </Box>
                    </Box>

                    {/* Group By Section */}
                    <Box className={classes.groupByWrapper}>
                        <Typography variant="h6" className={classes.sectionTitle}>
                            Critères de Regroupement
                        </Typography>
                        <Box className={classes.groupByCheckboxes}>
                            {['type_produit', 'tarif_produit', 'tranche_prix_r'].map(key => (
                                <FormControlLabel
                                    key={key}
                                    className={classes.checkboxLabel}
                                    control={
                                        <Checkbox
                                            color="primary"
                                            checked={groupBy[key]}
                                            onChange={() => {
                                                const updated = { ...groupBy, [key]: !groupBy[key] };
                                                const activeCount = Object.values(updated).filter(v => v).length;
                                                if (activeCount > 0) {
                                                    setGroupBy(updated);
                                                    fetchData(updated);
                                                } else {
                                                    alert('Veuillez sélectionner au moins un critère de regroupement.');
                                                }
                                            }}
                                        />
                                    }
                                    label={{
                                        type_produit: 'Type Produit',
                                        tarif_produit: 'Tarif Produit',
                                        tranche_prix_r: 'Tranche Prix R'
                                    }[key]}
                                />
                            ))}
                        </Box>
                    </Box>

                    {/* Button Section */}
                    <Box className={classes.buttonWrapper}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                fetchData(groupBy);
                                fetchInconsistencies();
                            }}
                            size="large"
                        >
                            Afficher les Données
                        </Button>
                    </Box>
                </Box>
            </Paper>

            <Grid container spacing={3} style={{ flexGrow: 1, height: '1px' }}>
                {data.length > 0 && (
                    <Grid item xs={12} md={6} className={classes.tableGridItem}>
                        <MaterialTable
                            title="Synthèse des Prix"
                            columns={buildColumns(groupBy)}
                            data={data}
                            options={{
                                sorting: true,
                                pageSize: 10,
                                pageSizeOptions: [5, 10, 20, 50, 100],
                                search: false,
                                toolbar: false,
                                paging: true,
                                padding: 'dense',
                                headerStyle: { whiteSpace: 'nowrap', fontWeight: 'bold' },
                                tableLayout: 'auto',
                                emptyDataSourceMessage: "Aucune donnée de synthèse trouvée.",
                                orderBy: buildColumns(groupBy).findIndex(col => col.field === sortOrderSynthesis.orderBy),
                                orderDirection: sortOrderSynthesis.orderDirection
                            }}
                            onOrderChange={handleSynthesisOrderChange}
                            onRowClick={(e, rowData) => fetchDetail(rowData)}
                            localization={localization}
                            className={classes.materialTableOverrides}
                        />
                    </Grid>
                )}

                {detailData.length > 0 && (
                    <Grid item xs={12} md={6} className={classes.tableGridItem}>
                        <MaterialTable
                            title="Détail pour la Sélection"
                            columns={detailColumns}
                            data={detailData}
                            options={{
                                sorting: true,
                                pageSize: 10,
                                pageSizeOptions: [5, 10, 20, 50, 100],
                                search: false,
                                toolbar: false,
                                paging: true,
                                padding: 'dense',
                                headerStyle: { whiteSpace: 'nowrap', fontWeight: 'bold' },
                                tableLayout: 'auto',
                                emptyDataSourceMessage: "Aucune donnée de détail trouvée.",
                                orderBy: detailColumns.findIndex(col => col.field === sortOrderDetail.orderBy),
                                orderDirection: sortOrderDetail.orderDirection
                            }}
                            onOrderChange={handleDetailOrderChange}
                            localization={localization}
                            className={classes.materialTableOverrides}
                        />
                    </Grid>
                )}

                {/* New Material Table for Inconsistencies with conditional rendering */}
                {inconsistencyData.length > 0 && (
                    <Grid item xs={12} className={classes.tableGridItem} style={{ marginTop: '24px' }}>
                        <MaterialTable
                            title="Produits Individuels Incohérents"
                            columns={inconsistencyColumns}
                            data={inconsistencyData}
                            options={{
                                sorting: true,
                                pageSize: 10,
                                pageSizeOptions: [5, 10, 20, 50, 100],
                                search: true,
                                toolbar: true,
                                paging: true,
                                padding: 'dense',
                                headerStyle: { whiteSpace: 'nowrap', fontWeight: 'bold' },
                                tableLayout: 'auto',
                                emptyDataSourceMessage: "Aucun produit incohérent trouvé avec les critères actuels.",
                                orderBy: inconsistencyColumns.findIndex(col => col.field === sortOrderInconsistency.orderBy),
                                orderDirection: sortOrderInconsistency.orderDirection
                            }}
                            onOrderChange={handleInconsistencyOrderChange}
                            localization={localization}
                            className={classes.materialTableOverrides}
                        />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}